export default {
  "Contains the street, city, zip, and state associated with an address.":
    "Contains the street, city, zip, and state associated with an address.",
  "Contains the street number and name": "Contains the street number and name",
  "Contains the additional street address information such as suite or apartment":
    "Contains the additional street address information such as suite or apartment",
  City: "City",
  County: "County",
  State: "State",
  "Zip code": "Zip code",
  "Contact information including phone numbers and email address.":
    "Contact information including phone numbers and email address.",
  "The coverages rated on the policy.": "The coverages rated on the policy.",
  "Bodily injury liability coverage helps pay for another person's expenses if you injure them in a car accident.":
    "Bodily injury liability coverage helps pay for another person's expenses if you injure them in a car accident.",
  "Property damage liability coverage helps pay for damage you cause to another person's vehicle or property.":
    "Property damage liability coverage helps pay for damage you cause to another person's vehicle or property.",
  "Medical payments coverage may help pay your or your passengers' medical expenses if you're injured in a car accident":
    "Medical payments coverage may help pay your or your passengers' medical expenses if you're injured in a car accident",
  "Uninsured motorist BI insurance protects you if you're in an accident with an at-fault driver who doesn't carry liability insurance.":
    "Uninsured motorist BI insurance protects you if you're in an accident with an at-fault driver who doesn't carry liability insurance.",
  "Uninsured motorist PD insurance protects you if you're in an accident with an at-fault driver who doesn't carry liability insurance.":
    "Uninsured motorist PD insurance protects you if you're in an accident with an at-fault driver who doesn't carry liability insurance.",
  "Accidental death and dismemberment (AD&D) is a policy that pays benefits to the beneficiary if the cause of death is an accident.":
    "Accidental death and dismemberment (AD&D) is a policy that pays benefits to the beneficiary if the cause of death is an accident.",
  "The coverages rated on the vehicle.": "The coverages rated on the vehicle.",
  "Collision insurance is a coverage that helps pay to repair or replace your car if it's damaged in an accident with another vehicle or object, such as a fence or a tree.":
    "Collision insurance is a coverage that helps pay to repair or replace your car if it's damaged in an accident with another vehicle or object, such as a fence or a tree.",
  "Comprehensive insurance is a coverage that helps pay to replace or repair your vehicle if it's stolen or damaged in an incident that's not a collision.":
    "Comprehensive insurance is a coverage that helps pay to replace or repair your vehicle if it's stolen or damaged in an incident that's not a collision.",
  "The vehicle's custom equipment value.":
    "The vehicle's custom equipment value.",
  "Gap insurance is coverage that helps pay off your auto loan if your car is totaled or stolen and you owe more than the car's depreciated value.":
    "Gap insurance is coverage that helps pay off your auto loan if your car is totaled or stolen and you owe more than the car's depreciated value.",
  "Rental Reimbursement helps pay your rental car costs while your car is being repaired as a result of a covered claim.":
    "Rental Reimbursement helps pay your rental car costs while your car is being repaired as a result of a covered claim.",
  "Roadside assistance typically protects you against some of the costs and hassles associated with common roadside breakdowns like dead batteries, flat tires or being locked out of your car.":
    "Roadside assistance typically protects you against some of the costs and hassles associated with common roadside breakdowns like dead batteries, flat tires or being locked out of your car.",
  "Safety coverage.": "Safety coverage.",
  "The named insured on the quote.": "The named insured on the quote.",
  "A tracking identifier provided by the API consumer.":
    "A tracking identifier provided by the API consumer.",
  "The customer's first name.": "The customer's first name.",
  "The customer's middle name.": "The customer's middle name.",
  "The customer's last name.": "The customer's last name.",
  "Did this customer decline to submit an email address?":
    "Did this customer decline to submit an email address?",
  "Did this customer decline to submit a phone number?":
    "Did this customer decline to submit a phone number?",
  "Customer's' address.": "Customer's' address.",
  "Customer's prior address.": "Customer's prior address.",
  "The customer's contact information'.":
    "The customer's contact information'.",
  "The number of months the customer has been at the current residence.":
    "The number of months the customer has been at the current residence.",
  "Did this customer decline to have his credit score run?":
    "Did this customer decline to have his credit score run?",
  "The number of residents in the current residence.":
    "The number of residents in the current residence.",
  "The customer's current insurance information.":
    "The customer's current insurance information.",
  "Contains the discount information of the driver.":
    "Contains the discount information of the driver.",
  "Apply a distant student discount?": "Apply a distant student discount?",
  "Apply a driver's training discount?": "Apply a driver's training discount?",
  "Apply a good student discount?": "Apply a good student discount?",
  "Apply a single parent discount?": "Apply a single parent discount?",
  "Apply a accident prevention course discount?":
    "Apply a accident prevention course discount?",
  "The date the accident prevention course was taken by the driver.":
    "The date the accident prevention course was taken by the driver.",
  "Apply a senior driver discount?": "Apply a senior driver discount?",
  "The date the senior driving course was taken by the driver.":
    "The date the senior driving course was taken by the driver.",
  "Does the driver have other policies with rating company?":
    "Does the driver have other policies with rating company?",
  "Companion policy information such as line of business, issuer, and policy number":
    "Companion policy information such as line of business, issuer, and policy number",
  "A rated or excluded driver on the quote.":
    "A rated or excluded driver on the quote.",
  "The id of the driver.  The first driver must have a value of 1.":
    "The id of the driver.  The first driver must have a value of 1.",
  "The driver's first name.": "The driver's first name.",
  "The driver's middle name.": "The driver's middle name.",
  "The driver's last name.": "The driver's last name.",
  "The driver's date of birth.": "The driver's date of birth.",
  "The driver's gender.": "The driver's gender.",
  "The driver's marital status.": "The driver's marital status.",
  "The number of months the driver has been employed.":
    "The number of months the driver has been employed.",
  "The driver's occupation.": "The driver's occupation.",
  "The driver's license information.": "The driver's license information.",
  "The driver's attributes.": "The driver's attributes.",
  "The driver discounts.": "The driver discounts.",
  "The driver's financial responsibility filings.":
    "The driver's financial responsibility filings.",
  "The driver's violations.": "The driver's violations.",
  "The driver's education level.": "The driver's education level.",
  "Is the driver an occasional operator of his vehicle?":
    "Is the driver an occasional operator of his vehicle?",
  "Does this driver have property insurance?":
    "Does this driver have property insurance?",
  "What is the relation of this driver to the named insured?":
    "What is the relation of this driver to the named insured?",
  "Does this driver own, rent, or lease his residence?":
    "Does this driver own, rent, or lease his residence?",
  "The type of residence the driver lives in.":
    "The type of residence the driver lives in.",
  "How many miles does the driver drive to work each day?":
    "How many miles does the driver drive to work each day?",
  "Driver's license information.": "Driver's license information.",
  "The license status of the driver.": "The license status of the driver.",
  "Driver's license number": "Driver's license number",
  "The number of months the driver has had a foreign license.":
    "The number of months the driver has had a foreign license.",
  "The number of months the driver has been licensed.":
    "The number of months the driver has been licensed.",
  "The number of months the driver has been licensed in the rating state.":
    "The number of months the driver has been licensed in the rating state.",
  "The number of months of MVR experience the driver has.":
    "The number of months of MVR experience the driver has.",
  "The number of months the driver has been suspended.":
    "The number of months the driver has been suspended.",
  "The state the driver is licensed in.":
    "The state the driver is licensed in.",
  "What kind of foreign license does the driver have?":
    "What kind of foreign license does the driver have?",
  "Is this driver a foreign national?": "Is this driver a foreign national?",
  "Does this driver have an international driver's license?":
    "Does this driver have an international driver's license?",
  "Information about the financial responsibility filing of the driver.":
    "Information about the financial responsibility filing of the driver.",
  "Does this driver require an SR-22?": "Does this driver require an SR-22?",
  "The reason for the financial responsibility filing.":
    "The reason for the financial responsibility filing.",
  "The financial responsibility filing state.":
    "The financial responsibility filing state.",
  "The financial responsibility filing date.":
    "The financial responsibility filing date.",
  "The financial responsibility filing case number.":
    "The financial responsibility filing case number.",
  "The lienholder information associated with a vehicle.":
    "The lienholder information associated with a vehicle.",
  "The name of the lienholder.": "The name of the lienholder.",
  "The address associated with the lienholder.":
    "The address associated with the lienholder.",
  "Is this a loan or a lease?": "Is this a loan or a lease?",
  "An agency fee to be tacked on the quote.":
    "An agency fee to be tacked on the quote.",
  "The amount of the fee.": "The amount of the fee.",
  "Should this fee be applied to the down payment?":
    "Should this fee be applied to the down payment?",
  "The description of the fee?": "The description of the fee?",
  "The amount based on total premium amount.":
    "The amount based on total premium amount.",
  "Should this fee be applied to the quote, each driver, or each vehicle?":
    "Should this fee be applied to the quote, each driver, or each vehicle?",
  "Phone number extension": "Phone number extension",
  "Contains the prior insurance information of the customer.":
    "Contains the prior insurance information of the customer.",
  "Was the prior insurance policy written in your agency?":
    "Was the Prior Insurance Policy written in this agency?",
  "The id of the prior carrier.": "The id of the prior carrier.",
  "The name of the prior carrier.": "The name of the prior carrier.",
  "The date the prior insurance policy expires.":
    "The date the prior insurance policy expires.",
  "Does this customer currently have insurance?":
    "Do you already have insurance?",
  "Prior carrier liability coverage.": "Prior carrier liability coverage.",
  "The number of months of prior insurance for the customer.":
    "The number of months of prior insurance for the customer.",
  "The reason the customer currently does not have insurance.":
    "The reason the customer currently does not have insurance.",
  "US state.": "US state.",
  "A vehicle on the quote.": "A vehicle on the quote.",
  "The id of the vehicle.  The first vehicle must have a value of 1.":
    "The id of the vehicle.  The first vehicle must have a value of 1.",
  "The vehicle's actual cash value.": "The vehicle's actual cash value.",
  "The vehicle's annual miles.": "The vehicle's annual miles.",
  "The id of the driver assigned to this vehicle.":
    "The id of the driver assigned to this vehicle.",
  "Is this a gray market vehicle?": "Is this a gray market vehicle?",
  "Does this vehicle have a homing device?":
    "Does this vehicle have a homing device?",
  "Does this vehicle have a hood lock?": "Does this vehicle have a hood lock?",
  "Is this vehicle leased?": "Is this vehicle leased?",
  "The vehicle's license plate number.'":
    "The vehicle's license plate number.'",
  "The list of lienholders for this vehicle.":
    "The list of lienholders for this vehicle.",
  "The vehicle's miles to work each day.":
    "The vehicle's miles to work each day.",
  "The vehicle's odometer reading.": "The vehicle's odometer reading.",
  "The percentage of this vehicle's driving amount that is spent driving to work.":
    "The percentage of this vehicle's driving amount that is spent driving to work.",
  "The purchase cost of the vehicle.": "The purchase cost of the vehicle.",
  "The date the vehicle was purchased.'":
    "The date the vehicle was purchased.'",
  "Was this vehicle purchased new or used?":
    "Was this vehicle purchased new or used?",
  "Is this vehicle used for ride sharing?":
    "Is this vehicle used for ride sharing?",
  "Has this vehicle been salvaged?": "Has this vehicle been salvaged?",
  "How is this vehicle used?": "How is this vehicle used?",
  "Does the client agree to use a device or an app to monitor this vehicle's usage?":
    "Does the client agree to use a device or an app to monitor this vehicle's usage?",
  VIN: "VIN",
  "Does this vehicle have VIN etching?": "Does this vehicle have VIN etching?",
  "A motor vehicle violation.": "A motor vehicle violation.",
  "Violation attributes (1). The meaning of each attribute varies by violation code":
    "Violation attributes (1). The meaning of each attribute varies by violation code",
  "Violation attributes (2). The meaning of each attribute varies by violation code":
    "Violation attributes (2). The meaning of each attribute varies by violation code",
  "The violation code.": "The violation code.",
  "The date the violation occurred.": "The date the violation occurred.",
  "Did this violation occur on the same day as another violation?":
    "Did this violation occur on the same day as another violation?",
  "Control bumping of invalid coverages.":
    "Control bumping of invalid coverages.",
  "The carriers to be rated.": "The carriers to be rated.",
  "Use the credentials passed for each CarrierInfo?":
    "Use the credentials passed for each CarrierInfo?",
  "The list of products to rate for the request":
    "The list of products to rate for the request",
  "The specific rating product for the carrier":
    "The specific rating product for the carrier",
  "The specific agency identifier": "The specific agency identifier",
  "The specific product's carrier identifier'":
    "The specific product's carrier identifier'",
  "The specific product's carrier name'":
    "The specific product's carrier name'",
  "The specific product's identifier'": "The specific product's identifier'",
  "The identifier for the product's program.'":
    "The identifier for the product's program.'",
  "The specific product's name'": "The specific product's name'",
  "The custom underwriting questions required to rate this product.  Each product will have it's own schema for validation.":
    "The custom underwriting questions required to rate this product.  Each product will have it's own schema for validation.",
  "The product's producer code": "The product's producer code",
  "The product's sub producer code": "The product's sub producer code",
  "The product's username": "The product's username",
  "The product's password": "The product's password",
  "An identifier supplied by the carrier for purposes of re-rating a quote":
    "An identifier supplied by the carrier for purposes of re-rating a quote",
  "The customer associated with the quote.":
    "The customer associated with the quote.",
  "The policy type of the quote.": "The policy type of the quote.",
  "The policy level coverages associated with the quote.":
    "The policy level coverages associated with the quote.",
  "All miscellaneous agency fees tacked on the quote.":
    "All miscellaneous agency fees tacked on the quote.",
  "The rated drivers on the quote.": "The rated drivers on the quote.",
  "The excluded drivers on the quote.": "The excluded drivers on the quote.",
  "The vehicles on the quote.": "The vehicles on the quote.",
  "The term on the quote.": "The term on the quote.",
  "The payment method on the quote.": "The payment method on the quote.",
  "The requested number of payments.": "The requested number of payments.",
  "The requested down payment percenage.":
    "The requested down payment percenage.",
  "Should a paperless discount be applied to this quote?":
    "Should a paperless discount be applied to this quote?",
  "Optional filter for pay plans.": "Optional filter for pay plans.",
  "Optional filter for agency bill.": "Optional filter for agency bill.",
  "The effective date of the quote.": "The effective date of the quote.",
  "The list of carriers on the request.":
    "The list of carriers on the request.",
};
